<template>
  <div>
    <div class="space-y-8 lg:space-y-12">
      <BasicDetailsForm :project="project" />

      <ProjectOwnerForm :project="project" />

      <ProjectProductForm :project="project" />

      <CoverForm :project="project" />

      <DeleteProjectForm :project="project" />
    </div>
  </div>
</template>

<script>
import BasicDetailsForm from '@/components/Projects/Settings/BasicDetailsForm.vue';
import CoverForm from '@/components/Projects/Settings/CoverForm.vue';
import ProjectOwnerForm from '@/components/Projects/Settings/ProjectOwnerForm.vue';
import ProjectProductForm from '@/components/Projects/Settings/ProjectProductForm.vue';
import DeleteProjectForm from '@/components/Projects/Settings/DeleteProjectForm.vue';

export default {
  name: 'General',

  components: {
    BasicDetailsForm,
    CoverForm,
    ProjectOwnerForm,
    DeleteProjectForm,
    ProjectProductForm,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectId];
    },
  },
};
</script>
